module.exports = __webpack_public_path__ + "static/media/business-corporation-organization-teamwork-concept-P8K92GH-min.c40613c2.jpg";